var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from "ethers";
import { useCallback, useEffect, useRef } from "react";
import { useWeb3React } from "@web3-react/core";
import { useWeb3Context } from "./web3Context";
import { useGlobalState } from "../store/store";
import { getVault } from "./useVault";
import { getDefaultChainID } from "../utils/env";
import { getAssets } from "../constants/constants";
import { isETHVault } from "../utils/vault";
import { getERC20Token } from "./useERC20Token";
import { impersonateAddress } from "../utils/development";
var useVaultData = function (vault, params) {
    var poll = Boolean(params && params.poll);
    var pollingFrequency = (params && params.pollingFrequency) || 4000;
    var isMountedRef = useRef(true);
    var _a = useWeb3React(), chainId = _a.chainId, library = _a.library, walletConnected = _a.active, web3Account = _a.account;
    var account = impersonateAddress ? impersonateAddress : web3Account;
    var ethersProvider = useWeb3Context().provider;
    var _b = useGlobalState("vaultData"), response = _b[0], setResponse = _b[1];
    var doMulticall = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var envChainID, zero, doSideEffect, providerVault, unconnectedPromises, connectedPromises, defaultToNextValue_1, defaultToPrevValue_1, signerVault, promises, responses_1, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    envChainID = getDefaultChainID();
                    zero = BigNumber.from("0");
                    doSideEffect = isMountedRef.current;
                    if (!ethersProvider) return [3 /*break*/, 4];
                    providerVault = getVault(ethersProvider, vault, false);
                    if (!providerVault) return [3 /*break*/, 4];
                    unconnectedPromises = [
                        providerVault.totalBalance(),
                        providerVault.cap(),
                        providerVault.maxWithdrawableShares(),
                        providerVault.totalSupply(),
                    ];
                    connectedPromises = [];
                    defaultToNextValue_1 = function (prevValue, nextValue) { return (prevValue.isZero() ? nextValue : prevValue); };
                    defaultToPrevValue_1 = function (prevValue, nextValue) { return (nextValue.isZero() ? prevValue : nextValue); };
                    if (walletConnected && account && chainId) {
                        if (chainId !== envChainID) {
                            doSideEffect &&
                                setResponse(function (prevResponse) {
                                    var _a;
                                    return (__assign(__assign({}, prevResponse), (_a = {}, _a[vault] = __assign(__assign({}, prevResponse[vault]), { status: "error", error: "wrong_network", deposits: defaultToNextValue_1(zero, prevResponse[vault].deposits), vaultLimit: defaultToNextValue_1(zero, prevResponse[vault].vaultLimit), vaultMaxWithdrawAmount: defaultToNextValue_1(zero, prevResponse[vault].vaultLimit), vaultBalanceInAsset: defaultToNextValue_1(zero, prevResponse[vault].vaultBalanceInAsset), userAssetBalance: defaultToNextValue_1(zero, prevResponse[vault].userAssetBalance), maxWithdrawAmount: defaultToNextValue_1(zero, prevResponse[vault].maxWithdrawAmount) }), _a)));
                                });
                            return [2 /*return*/];
                        }
                        signerVault = getVault(library, vault);
                        if (signerVault) {
                            connectedPromises = [
                                signerVault.accountVaultBalance(account),
                                isETHVault(vault)
                                    ? library.getBalance(account)
                                    : (_a = getERC20Token(library, getAssets(vault).toLowerCase())) === null || _a === void 0 ? void 0 : _a.balanceOf(account),
                                signerVault.maxWithdrawAmount(account),
                            ];
                        }
                    }
                    promises = unconnectedPromises.concat(connectedPromises);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all(promises)];
                case 2:
                    responses_1 = _b.sent();
                    if (!walletConnected) {
                        doSideEffect &&
                            setResponse(function (prevResponse) {
                                var _a;
                                return (__assign(__assign({}, prevResponse), (_a = {}, _a[vault] = __assign(__assign({}, prevResponse[vault]), { status: "success", error: null, deposits: defaultToPrevValue_1(prevResponse[vault].deposits, responses_1[0]), vaultLimit: defaultToPrevValue_1(prevResponse[vault].vaultLimit, responses_1[1]), vaultMaxWithdrawAmount: defaultToPrevValue_1(prevResponse[vault].vaultMaxWithdrawAmount, responses_1[2].mul(responses_1[0]).div(responses_1[3])), vaultBalanceInAsset: zero, userAssetBalance: zero, maxWithdrawAmount: zero }), _a)));
                            });
                        return [2 /*return*/];
                    }
                    doSideEffect &&
                        setResponse(function (prevResponse) {
                            var _a;
                            return (__assign(__assign({}, prevResponse), (_a = {}, _a[vault] = __assign(__assign({}, prevResponse[vault]), { status: "success", error: null, deposits: defaultToPrevValue_1(prevResponse[vault].deposits, responses_1[0]), vaultLimit: defaultToPrevValue_1(prevResponse[vault].vaultLimit, responses_1[1]), vaultMaxWithdrawAmount: defaultToPrevValue_1(prevResponse[vault].vaultMaxWithdrawAmount, responses_1[2].mul(responses_1[0]).div(responses_1[3])), vaultBalanceInAsset: defaultToPrevValue_1(prevResponse[vault].vaultBalanceInAsset, responses_1[4]), userAssetBalance: defaultToPrevValue_1(prevResponse[vault].userAssetBalance, responses_1[5]), maxWithdrawAmount: defaultToPrevValue_1(prevResponse[vault].maxWithdrawAmount, responses_1[6]) }), _a)));
                        });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    console.error(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [
        vault,
        account,
        ethersProvider,
        setResponse,
        walletConnected,
        chainId,
        library,
    ]);
    useEffect(function () {
        // eslint-disable-next-line no-undef
        var pollInterval = null;
        if (poll) {
            doMulticall();
            pollInterval = setInterval(doMulticall, pollingFrequency);
        }
        else {
            doMulticall();
        }
        return function () {
            if (pollInterval) {
                clearInterval(pollInterval);
            }
        };
    }, [poll, pollingFrequency, doMulticall]);
    return response[vault];
};
export default useVaultData;
//# sourceMappingURL=useVaultData.js.map